import { axiosInstance } from '../request';
export const getCameraStreamSettings = async () => {
    const response = await axiosInstance.get('/api/v1/cameras/stream-settings');
    return response.data;
};
export const addCamera = async () => {
    const response = await axiosInstance.post('/api/v1/cameras/streams');
    return response.data;
};
export const regenerateCameraStreamKey = async (cameraId) => {
    const response = await axiosInstance.post(`/api/v1/cameras/streams/${cameraId}/regenerate`);
    return response.data;
};
export const deleteCamera = async (cameraId) => {
    const response = await axiosInstance.delete(`/api/v1/cameras/streams/${cameraId}`);
    return response.data;
};
//# sourceMappingURL=cameras.api.js.map